import Swiper from 'swiper';
import * as FilePond from 'filepond'

export default {
    init() {
    /**
     * Swiper GIF Picker
     */

     new Swiper('.gifSwiper', {
        direction: 'vertical',
        slidesPerView: 2.5,
        spaceBetween: 10,
        loop: true,
        centeredSlides: true,
     });
        
    // Get a reference to the file input element
        const inputElement = document.querySelector('#vidUpload');
 

    if (inputElement) {
        // Create a FilePond instance
       FilePond.create(inputElement);
    }
    
    /**
     * Add to preview product page
     */

        const addToPreview = document.getElementById('addToPreview');
        
        if (addToPreview) {

            addToPreview.addEventListener('click', () => {
                // Get picked GIF and textarea
                let target = document.querySelector('.swiper-slide-active > img').src;
                let targetText = document.getElementById('personal-message').value;
                let previewEl = document.getElementById('preview');

                // Get preview text el
                let targetPreviewText = document.getElementById('preview-msg');

                // If img tag exists change src
                let imageTagReady = document.getElementById('previewGif');
         
                if (imageTagReady) {
                    imageTagReady.src = target;
                    targetPreviewText.innerText = targetText;

                    // Add data to data attributes
                    previewEl.dataset.file = target;
                    targetPreviewText.dataset.msg = targetText;

                    document.getElementById('preview-center').scrollIntoView({ behavior: 'smooth', block: 'center' });
                } else {
                    // Creat img tag etc. and get target container
                    let imageTag = document.createElement('img');
                    imageTag.id = 'previewGif';
                    imageTag.src = target;

                    previewEl.appendChild(imageTag);
             
                    targetPreviewText.innerText = targetText;
             
                    // Add data to data attributes
                    previewEl.dataset.file = target;
                    targetPreviewText.dataset.msg = targetText;

                    document.getElementById('preview-center').scrollIntoView({ behavior: 'smooth', block: 'center' });
                }

                $('#orderData').on('click', (e) => {

                    e.preventDefault();

                    let checkoutLink = e.target.href;
             
                    const previewFile = document.getElementById('preview');
                    const previewMsg = document.getElementById('preview-msg');
             
                    let fileData = previewFile.dataset.file;
                    let msgData = previewMsg.dataset.msg;

                    let formData = {
                        file: fileData,
                        message: msgData,
                    };

                    $.ajax({
                        url: '/wp-admin/admin-ajax.php?action=product_data_encrypt', // Url of backend (can be python, php, etc..)
                        type: 'POST', // data type (can be get, post, put, delete)
                        data: formData, // data in json format
                
                        success: function (data) {
                            checkoutLink = checkoutLink + data;
                            location.href = checkoutLink;
                        },
                    });
                })
            });
            
        }
        
    },
  };
  


// WEBPACK FOOTER //
// ./scripts/routes/singleProduct.js